// Shared agent display helpers — persona color (mirrors the 3D office) and the
// "Name — Role" split, so every agent card across the app reads consistently.

export const AGENT_COLORS: Record<string, string> = {
  orchestrator: "#00b886",
  agent_1_statement_retrieval: "#0091d6",
  agent_2_bank_import: "#ff9040",
  agent_3_qb_posting: "#2ca01c",
  agent_4_invoice_collector: "#b23cff",
  agent_5_matching: "#ff4466",
  agent_watchdog: "#7a869a",
  qb_drift_scanner: "#7a869a",
};

export function agentColor(agentId?: string): string {
  return (agentId && AGENT_COLORS[agentId]) || "#7a869a";
}

/** Split a stored "Name — Role" agentName into its parts. */
export function splitAgentName(agentName?: string): { name: string; role: string } {
  const raw = (agentName ?? "").trim();
  const m = raw.split(/\s+—\s+/);
  if (m.length >= 2) return { name: m[0], role: m.slice(1).join(" — ") };
  return { name: raw, role: "" };
}

/** Hex → rgba string for subtle color tints. */
export function tint(hex: string, alpha: number): string {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}
